<template>
    <div class="k-price-lv">
<!--        <div class="k-lv-line"></div>-->
        <div class="k-lv-box">
            <div class="k-lv--item" v-for="(item, key) in lvList" :key="key" :class="{active:lv==key}">
                <span class="k-lv--round"><k-icon name="success" size="10"></k-icon></span>
                <div class="k-lv--title">{{item}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "k-price-lv",
        props : ["lv", "lvList"],
        data(){
            return {
                /*lvList :[
                    "价格透明稳定",
                    "价格趋向上涨",
                    "升值空间较大",
                    "行情波动较大",
                ]*/
            }
        }
    }
</script>

<style lang="less" scoped>
    .k-price-lv {
        padding: 0.2rem;
    }
    .k-lv-box {
        display: flex;
        align-items: flex-start;
        text-align : center;
        font-size: 0.24rem;
        position: relative;
        color: #999;
        .k-lv--round {
            display: inline-block;
            width: 0.2rem;
            height: 0.2rem;
            border-radius: 50%;
            background-color: #eee;
            border: 1px solid #fff;
            line-height: 1;
            color: #eee;
        }
        .k-lv--item {
            flex: 1;
            z-index: 2;
            &.active {
                .k-lv--round {
                    width: 0.3rem;
                    height: 0.3rem;
                    background-color: #CEA065;
                    color: #fff;
                    line-height: 1.2;
                }
                .k-lv--title {
                    color: #CEA065;
                }
            }
        }
        &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0.18rem;
            width: 100%;
            height: 4px;
            background-color: #eee;
            z-index: 1;
        }
    }
</style>